import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const POZICIA_LABELS: Record<string, string> = {
  brankar: "Brankári",
  obranca: "Obrancovia",
  utocnik: "Útočníci",
};

export const STRANA_HOKEJKY_LABELS: Record<string, string> = {
  L: "Ľavá",
  P: "Pravá",
};

export const STAV_ZDRAVIA_LABELS: Record<string, string> = {
  fit: "Fit",
  zraneny: "Zranený",
  otaznik: "Otáznik",
  nezname: "—",
};

export const STAV_ZDRAVIA_COLORS: Record<string, string> = {
  fit: "text-status-success bg-status-success/15 border-status-success/20",
  zraneny: "text-status-error bg-status-error/15 border-status-error/20",
  otaznik: "text-status-warning bg-status-warning/15 border-status-warning/20",
  nezname: "text-muted-foreground bg-muted border-muted-foreground/20",
};

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("sk-SK", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function formatDateTime(dateString: string): string {
  return new Date(dateString).toLocaleString("sk-SK", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function isHlasovanieAktivne(hlasovanie: {
  je_aktivne: boolean;
  zaciatok: string;
  koniec: string;
}): boolean {
  if (!hlasovanie.je_aktivne) return false;
  const now = new Date();
  return (
    now >= new Date(hlasovanie.zaciatok) && now <= new Date(hlasovanie.koniec)
  );
}
